// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Button,
//   Table,
//   Tbody,
//   Td,
//   Th,
//   Thead,
//   Tr,
//   VStack,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalBody,
//   ModalCloseButton,
// } from '@chakra-ui/react';
// import axios from 'axios';
// import api from 'contexts/api';

// import Form from './form.jsx'; // Importe o componente Form corretamente

// const Index = () => {
//   const [users, setUsers] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null); // Alterado para armazenar o usuário selecionado

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const response = await api.get('/users');
//       console.log(response)
//       setUsers(response.data.users);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const deleteUser = async (userId) => {
//     try {
//       await api.delete(`/users/${userId}`);
//       fetchUsers();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const openModal = (user = null) => {
//     setSelectedUser(user); // Define o usuário selecionado
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setSelectedUser(null); // Reseta o usuário selecionado
//     setIsModalOpen(false);
//   };

//   const handleSubmit = () => {
//     fetchUsers();
//     closeModal();
//   };

//   return (
//     <Box mt={{ sm: '140px', md: '12%', lg: '15%', xl: '6%' }}>
//       <VStack spacing={4} align="stretch">
//         <Table variant="striped" w='98%' size="sm" maxWidth="100%">
//           <Thead>
//             <Tr>
//               <Th>Nome</Th>
//               <Th>Email</Th>
//               <Th>Vendedor</Th>
//               <Th>banco</Th>
//               <Th>Perfil</Th>
//               <Th>Ações</Th>
//             </Tr>
//           </Thead>
//           <Tbody>
//             {users.map((user) => (
//               <Tr key={user.user_id}>
//                 <Td>{user.name}</Td>
//                 <Td>{user.email}</Td>
//                 <Td>{user.vendedor}</Td>
//                 <Td>{user.banco}</Td>
//                 <Td>{user.perfil}</Td>
//                 <Td>
//                   {/* <Button colorScheme="red" size="sm" onClick={() => deleteUser(user.user_id)}>
//                     Excluir
//                   </Button> */}
//                   <Button colorScheme="blue" ml={1} size="sm" onClick={() => openModal(user)}>
//                     Editar
//                   </Button>
//                 </Td>
//               </Tr>
//             ))}
//           </Tbody>
//         </Table>
//         <Button w={'5%'} size="sm" fontSize={{ sm: "10px" }} colorScheme="blue" onClick={() => openModal()}>
//           Incluir
//         </Button>
//       </VStack>

//       <Modal isOpen={isModalOpen} onClose={closeModal}>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>{selectedUser ? 'Editar Usuário' : 'Incluir Usuário'}</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <Form user={selectedUser} onSubmit={handleSubmit} /> {/* Passa o usuário selecionado para o componente Form */}
//           </ModalBody>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// };

// export default Index;
// import React, { useEffect, useState } from 'react';
// import {
//   AlertDialog,
//   AlertDialogBody,
//   AlertDialogFooter,
//   AlertDialogHeader,
//   AlertDialogContent,
//   AlertDialogOverlay
// } from '@chakra-ui/react';
// import { useRef } from 'react';
// import {
//   Box,
//   Button,
//   Table,
//   Tbody,
//   Td,
//   Th,
//   Thead,
//   Tr,
//   VStack,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalBody,
//   ModalCloseButton,
//   Input,
//   FormControl,
//   FormLabel,
//   HStack,
//   Icon,
// } from '@chakra-ui/react';
// import { SearchIcon } from '@chakra-ui/icons';
// import { FiTrash2, FiDownload } from 'react-icons/fi';
// import api from 'contexts/api';
// import Form from './form.jsx';

// const Index = () => {
//   const [users, setUsers] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [searchName, setSearchName] = useState('');
//   const [searchEmail, setSearchEmail] = useState('');
//   const [searchVendedor, setSearchVendedor] = useState('');

//   const [isAlertOpen, setIsAlertOpen] = useState(false);
//   const [userToDelete, setUserToDelete] = useState(null);
//   const cancelRef = useRef();

//   const confirmDeleteUser = (user) => {
//     setUserToDelete(user);
//     setIsAlertOpen(true);
//   };

//   const handleConfirmDelete = async () => {
//     try {
//       await deleteUser(userToDelete.user_id);
//       setIsAlertOpen(false);
//       setUserToDelete(null);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const response = await api.get('/users');
//       setUsers(response.data.users);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const deleteUser = async (userId) => {
//     try {
//       await api.delete(`/users/${userId}`);
//       fetchUsers();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const handleBackup = async (userId) => {
//     try {
//       const response = await api.get(`/users/${userId}/backup`, { responseType: 'blob' });
//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `backup_${userId}.zip`);
//       document.body.appendChild(link);
//       link.click();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const openModal = (user = null) => {
//     setSelectedUser(user);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setSelectedUser(null);
//     setIsModalOpen(false);
//   };

//   const handleSubmit = () => {
//     fetchUsers();
//     closeModal();
//   };

//   const filteredUsers = users.filter((user) => {
//     return (
//       (user.name?.toLowerCase() || '').includes(searchName.toLowerCase()) &&
//       (user.email?.toLowerCase() || '').includes(searchEmail.toLowerCase()) &&
//       (user.vendedor?.toLowerCase() || '').includes(searchVendedor.toLowerCase())
//     );
//   });

//   return (
//     <Box mt={{ sm: '140px', md: '12%', lg: '15%', xl: '6%' }} px={4}>
//       <AlertDialog
//         isOpen={isAlertOpen}
//         leastDestructiveRef={cancelRef}
//         onClose={() => setIsAlertOpen(false)}
//         isCentered
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader fontSize="lg" fontWeight="bold">
//               Confirmar Exclusão
//             </AlertDialogHeader>

//             <AlertDialogBody>
//               Tem certeza que deseja excluir o usuário{' '}
//               <strong>{userToDelete?.name}</strong>?
//               Esta ação não poderá ser desfeita.
//             </AlertDialogBody>

//             <AlertDialogFooter>
//               <Button ref={cancelRef} onClick={() => setIsAlertOpen(false)}>
//                 Cancelar
//               </Button>
//               <Button colorScheme="red" onClick={handleConfirmDelete} ml={3}>
//                 Excluir
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>
//       <VStack spacing={4} align="stretch">
//         <HStack spacing={4}>
//           <FormControl>
//             <FormLabel>Filtrar por Nome</FormLabel>
//             <Input
//               placeholder="Nome"
//               value={searchName}
//               onChange={(e) => setSearchName(e.target.value)}
//               bg="white"
//             />
//           </FormControl>

//           <FormControl>
//             <FormLabel>Filtrar por Email</FormLabel>
//             <Input
//               placeholder="Email"
//               value={searchEmail}
//               onChange={(e) => setSearchEmail(e.target.value)}
//               bg="white"
//             />
//           </FormControl>

//           <FormControl>
//             <FormLabel>Filtrar por Vendedor</FormLabel>
//             <Input
//               placeholder="Vendedor"
//               value={searchVendedor}
//               onChange={(e) => setSearchVendedor(e.target.value)}
//               bg="white"
//             />
//           </FormControl>
//         </HStack>

//         <Box overflowX="auto" bg="white" borderRadius="md" boxShadow="md" p={4}>
//           <Table variant="striped" size="sm">
//             <Thead>
//               <Tr>
//                 <Th>Nome</Th>
//                 <Th>Email</Th>
//                 <Th>Vendedor</Th>
//                 <Th>Banco</Th>
//                 <Th>Perfil</Th>
//                 <Th>Ações</Th>
//               </Tr>
//             </Thead>
//             <Tbody>
//               {filteredUsers.map((user) => (
//                 <Tr key={user.user_id} _hover={{ bg: 'gray.100' }}>
//                   <Td>{user.name}</Td>
//                   <Td>{user.email}</Td>
//                   <Td>{user.vendedor}</Td>
//                   <Td>{user.banco}</Td>
//                   <Td>{user.perfil}</Td>
//                   <Td>
//                     <HStack spacing={1}>
//                       <Button size="xs" colorScheme="blue" onClick={() => openModal(user)}>
//                         Editar
//                       </Button>
//                       <Button size="xs" colorScheme="red" onClick={() => confirmDeleteUser(user)}>
//                         <Icon as={FiTrash2} />
//                       </Button>
//                       <Button size="xs" colorScheme="green" onClick={() => handleBackup(user.user_id)}>
//                         <Icon as={FiDownload} />
//                       </Button>
//                     </HStack>
//                   </Td>
//                 </Tr>
//               ))}
//             </Tbody>
//           </Table>
//         </Box>

//         <Button w="fit-content" size="sm" fontSize={{ sm: '12px' }} colorScheme="blue" onClick={() => openModal()}>
//           Incluir Usuário
//         </Button>
//       </VStack>

//       <Modal isOpen={isModalOpen} onClose={closeModal} isCentered>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>{selectedUser ? 'Editar Usuário' : 'Incluir Usuário'}</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <Form user={selectedUser} onSubmit={handleSubmit} />
//           </ModalBody>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// };

// export default Index;



//versao final
// import React, { useEffect, useState, useRef } from 'react';
// import {
//   Box,
//   Button,
//   Table,
//   Tbody,
//   Td,
//   Th,
//   Thead,
//   Tr,
//   VStack,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalBody,
//   ModalCloseButton,
//   Input,
//   FormControl,
//   FormLabel,
//   HStack,
//   Icon,
//   AlertDialog,
//   AlertDialogBody,
//   AlertDialogFooter,
//   AlertDialogHeader,
//   AlertDialogContent,
//   AlertDialogOverlay,
// } from '@chakra-ui/react';
// import { SearchIcon } from '@chakra-ui/icons';
// import { FiTrash2, FiDownload } from 'react-icons/fi';
// import api from 'contexts/api';
// import Form from './form.jsx';

// const Index = () => {
//   const [users, setUsers] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [searchName, setSearchName] = useState('');
//   const [searchEmail, setSearchEmail] = useState('');
//   const [searchVendedor, setSearchVendedor] = useState('');
//   const [isAlertOpen, setIsAlertOpen] = useState(false);
//   const [userToDelete, setUserToDelete] = useState(null);
//   const cancelRef = useRef();

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     try {
//       const response = await api.get('/users');
//       setUsers(response.data.users);
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const deleteUser = async (userId) => {
//     try {
//       await api.delete(`/users/${userId}`);
//       fetchUsers();
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   const confirmDeleteUser = (user) => {
//     setUserToDelete(user);
//     setIsAlertOpen(true);
//   };

//   const handleConfirmDelete = async () => {
//     if (!userToDelete) return;
//     await deleteUser(userToDelete.user_id);
//     setIsAlertOpen(false);
//     setUserToDelete(null);
//   };

//   const handleBackup = async (userId, mongoUri, dbName) => {
//     try {
//       const encodedUri = encodeURIComponent(mongoUri);
//       const encodedDb = encodeURIComponent(dbName);

//       const response = await api.get(`/backup?mongoUri=${encodedUri}&dbName=${encodedDb}`, {
//         responseType: 'blob',
//       });

//       const url = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = url;
//       link.setAttribute('download', `backup_${userId}.zip`);
//       document.body.appendChild(link);
//       link.click();
//     } catch (error) {
//       console.error(error);
//     }
//   };


//   const openModal = (user = null) => {
//     setSelectedUser(user);
//     setIsModalOpen(true);
//   };

//   const closeModal = () => {
//     setSelectedUser(null);
//     setIsModalOpen(false);
//   };

//   const handleSubmit = () => {
//     fetchUsers();
//     closeModal();
//   };

//   const filteredUsers = users.filter((user) => {
//     return (
//       (user.name?.toLowerCase() || '').includes(searchName.toLowerCase()) &&
//       (user.email?.toLowerCase() || '').includes(searchEmail.toLowerCase()) &&
//       (user.vendedor?.toLowerCase() || '').includes(searchVendedor.toLowerCase())
//     );
//   });

//   return (
//     <Box mt={{ sm: '140px', md: '12%', lg: '15%', xl: '6%' }} px={4}>
//       <VStack spacing={4} align="stretch">
//         <HStack spacing={4}>
//           <FormControl>
//             <FormLabel>Filtrar por Nome</FormLabel>
//             <Input
//               placeholder="Nome"
//               value={searchName}
//               onChange={(e) => setSearchName(e.target.value)}
//               bg="white"
//             />
//           </FormControl>

//           <FormControl>
//             <FormLabel>Filtrar por Email</FormLabel>
//             <Input
//               placeholder="Email"
//               value={searchEmail}
//               onChange={(e) => setSearchEmail(e.target.value)}
//               bg="white"
//             />
//           </FormControl>

//           <FormControl>
//             <FormLabel>Filtrar por Vendedor</FormLabel>
//             <Input
//               placeholder="Vendedor"
//               value={searchVendedor}
//               onChange={(e) => setSearchVendedor(e.target.value)}
//               bg="white"
//             />
//           </FormControl>
//         </HStack>

//         <Box overflowX="auto" bg="white" borderRadius="md" boxShadow="md" p={4}>
//           <Table variant="striped" size="sm">
//             <Thead>
//               <Tr>
//                 <Th>Nome</Th>
//                 <Th>Email</Th>
//                 <Th>Vendedor</Th>
//                 <Th>Banco</Th>
//                 <Th>Perfil</Th>
//                 <Th>Ações</Th>
//               </Tr>
//             </Thead>
//             <Tbody>
//               {filteredUsers.map((user) => (
//                 <Tr key={user.user_id} _hover={{ bg: 'gray.100' }}>
//                   <Td>{user.name}</Td>
//                   <Td>{user.email}</Td>
//                   <Td>{user.vendedor}</Td>
//                   <Td>{user.banco}</Td>
//                   <Td>{user.perfil}</Td>
//                   <Td>
//                     <HStack spacing={1}>
//                       <Button size="xs" colorScheme="blue" onClick={() => openModal(user)}>
//                         Editar
//                       </Button>
//                       <Button size="xs" colorScheme="red" onClick={() => confirmDeleteUser(user)}>
//                         <Icon as={FiTrash2} />
//                       </Button>
//                       <Button
//                         size="xs"
//                         colorScheme="green"
//                         onClick={() => handleBackup(user.user_id, user.banco, user.db)}
//                       >
//                         <Icon as={FiDownload} />
//                       </Button>
//                     </HStack>
//                   </Td>
//                 </Tr>
//               ))}
//             </Tbody>
//           </Table>
//         </Box>

//         <Button w="fit-content" size="sm" fontSize={{ sm: '12px' }} colorScheme="blue" onClick={() => openModal()}>
//           Incluir Usuário
//         </Button>
//       </VStack>

//       <Modal isOpen={isModalOpen} onClose={closeModal} isCentered>
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>{selectedUser ? 'Editar Usuário' : 'Incluir Usuário'}</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <Form user={selectedUser} onSubmit={handleSubmit} />
//           </ModalBody>
//         </ModalContent>
//       </Modal>

//       <AlertDialog
//         isOpen={isAlertOpen}
//         leastDestructiveRef={cancelRef}
//         onClose={() => setIsAlertOpen(false)}
//         isCentered
//       >
//         <AlertDialogOverlay>
//           <AlertDialogContent>
//             <AlertDialogHeader fontSize="lg" fontWeight="bold">
//               Confirmar Exclusão
//             </AlertDialogHeader>

//             <AlertDialogBody>
//               Tem certeza que deseja excluir o usuário{' '}
//               <strong>{userToDelete?.name}</strong>? Esta ação não poderá ser desfeita.
//             </AlertDialogBody>

//             <AlertDialogFooter>
//               <Button ref={cancelRef} onClick={() => setIsAlertOpen(false)}>
//                 Cancelar
//               </Button>
//               <Button colorScheme="red" onClick={handleConfirmDelete} ml={3}>
//                 Excluir
//               </Button>
//             </AlertDialogFooter>
//           </AlertDialogContent>
//         </AlertDialogOverlay>
//       </AlertDialog>
//     </Box>
//   );
// };

// export default Index;


import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Button,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  VStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Input,
  FormControl,
  FormLabel,
  HStack,
  Icon,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Spinner,
  Center,
  Text,
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { FiTrash2, FiDownload } from 'react-icons/fi';
import api from 'contexts/api';
import Form from './form.jsx';

const Index = () => {
  const [users, setUsers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [searchName, setSearchName] = useState('');
  const [searchEmail, setSearchEmail] = useState('');
  const [searchVendedor, setSearchVendedor] = useState('');
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  const cancelRef = useRef();

  // Novo estado para controle do loader de backup
  const [loadingBackup, setLoadingBackup] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await api.get('/users');
      setUsers(response.data.users);
    } catch (error) {
      console.error(error);
    }
  };

  const deleteUser = async (userId) => {
    try {
      await api.delete(`/users/${userId}`);
      fetchUsers();
    } catch (error) {
      console.error(error);
    }
  };

  const confirmDeleteUser = (user) => {
    setUserToDelete(user);
    setIsAlertOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!userToDelete) return;
    await deleteUser(userToDelete.user_id);
    setIsAlertOpen(false);
    setUserToDelete(null);
  };

  const handleBackup = async (userId, mongoUri, dbName) => {
    setLoadingBackup(true); // mostra loader e bloqueia tela
    try {
      const encodedUri = encodeURIComponent(mongoUri);
      const encodedDb = encodeURIComponent(dbName);

      const response = await api.get(`/backup?mongoUri=${encodedUri}&dbName=${encodedDb}`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `backup_${userId}.zip`);
      document.body.appendChild(link);
      link.click();

      // Limpando o link criado após o download
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert('Erro ao gerar backup');
    } finally {
      setLoadingBackup(false); // esconde loader e desbloqueia tela
    }
  };

  const openModal = (user = null) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedUser(null);
    setIsModalOpen(false);
  };

  const handleSubmit = () => {
    fetchUsers();
    closeModal();
  };

  const filteredUsers = users.filter((user) => {
    return (
      (user.name?.toLowerCase() || '').includes(searchName.toLowerCase()) &&
      (user.email?.toLowerCase() || '').includes(searchEmail.toLowerCase()) &&
      (user.vendedor?.toLowerCase() || '').includes(searchVendedor.toLowerCase())
    );
  });

  return (
    <Box mt={{ sm: '140px', md: '12%', lg: '15%', xl: '6%' }} px={4} position="relative">
      
      {/* Overlay de loading para bloquear a tela durante backup */}
      {loadingBackup && (
        <Box
          position="fixed"
          top="0"
          left="0"
          width="100vw"
          height="100vh"
          backgroundColor="rgba(0,0,0,0.5)"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          zIndex="9999"
        >
          <Spinner size="xl" thickness="4px" color="blue.500" />
          <Text mt={4} color="white" fontSize="lg" fontWeight="bold">
            Gerando backup, por favor aguarde...
          </Text>
        </Box>
      )}

      <VStack spacing={4} align="stretch" opacity={loadingBackup ? 0.5 : 1} pointerEvents={loadingBackup ? 'none' : 'auto'}>
        <HStack spacing={4}>
          <FormControl>
            <FormLabel>Filtrar por Nome</FormLabel>
            <Input
              placeholder="Nome"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              bg="white"
              disabled={loadingBackup}
            />
          </FormControl>

          <FormControl>
            <FormLabel>Filtrar por Email</FormLabel>
            <Input
              placeholder="Email"
              value={searchEmail}
              onChange={(e) => setSearchEmail(e.target.value)}
              bg="white"
              disabled={loadingBackup}
            />
          </FormControl>

          <FormControl>
            <FormLabel>Filtrar por Vendedor</FormLabel>
            <Input
              placeholder="Vendedor"
              value={searchVendedor}
              onChange={(e) => setSearchVendedor(e.target.value)}
              bg="white"
              disabled={loadingBackup}
            />
          </FormControl>
        </HStack>

        <Box overflowX="auto" bg="white" borderRadius="md" boxShadow="md" p={4}>
          <Table variant="striped" size="sm">
            <Thead>
              <Tr>
                <Th>Nome</Th>
                <Th>Email</Th>
                <Th>Vendedor</Th>
                <Th>Banco</Th>
                <Th>Perfil</Th>
                <Th>Ações</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredUsers.map((user) => (
                <Tr key={user.user_id} _hover={{ bg: 'gray.100' }}>
                  <Td>{user.name}</Td>
                  <Td>{user.email}</Td>
                  <Td>{user.vendedor}</Td>
                  <Td>{user.banco}</Td>
                  <Td>{user.perfil}</Td>
                  <Td>
                    <HStack spacing={1}>
                      <Button size="xs" colorScheme="blue" onClick={() => openModal(user)} disabled={loadingBackup}>
                        Editar
                      </Button>
                      <Button size="xs" colorScheme="red" onClick={() => confirmDeleteUser(user)} disabled={loadingBackup}>
                        <Icon as={FiTrash2} />
                      </Button>
                      <Button
                        size="xs"
                        colorScheme="green"
                        onClick={() => handleBackup(user.user_id, user.banco, user.db)}
                        disabled={loadingBackup}
                      >
                        <Icon as={FiDownload} />
                      </Button>
                    </HStack>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>

        <Button
          w="fit-content"
          size="sm"
          fontSize={{ sm: '12px' }}
          colorScheme="blue"
          onClick={() => openModal()}
          disabled={loadingBackup}
        >
          Incluir Usuário
        </Button>
      </VStack>

      <Modal isOpen={isModalOpen} onClose={closeModal} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{selectedUser ? 'Editar Usuário' : 'Incluir Usuário'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Form user={selectedUser} onSubmit={handleSubmit} />
          </ModalBody>
        </ModalContent>
      </Modal>

      <AlertDialog
        isOpen={isAlertOpen}
        leastDestructiveRef={cancelRef}
        onClose={() => setIsAlertOpen(false)}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Confirmar Exclusão
            </AlertDialogHeader>

            <AlertDialogBody>
              Tem certeza que deseja excluir o usuário{' '}
              <strong>{userToDelete?.name}</strong>? Esta ação não poderá ser desfeita.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button ref={cancelRef} onClick={() => setIsAlertOpen(false)} disabled={loadingBackup}>
                Cancelar
              </Button>
              <Button colorScheme="red" onClick={handleConfirmDelete} ml={3} disabled={loadingBackup}>
                Excluir
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};

export default Index;
